import { consolidated } from "./consolidated";
import { financial } from "./financial";
import { withdraws } from "./withdraws";
import { devolution } from "./devolution";
import { adjustments } from "./adjustments";
import { accounts } from "./accounts";
import { flow } from "./flow";
import { anticipationDrawer } from "./anticipation-drawer";
import { withdrawRequestDrawer } from "./withdraw-request-drawer";
import { errorsValidations } from "./errors-validations";
import { transferForm } from "./transfer-form";
import { withdrawConfirmation } from "./withdraw-confirmation";
import { withdrawRequestDetails } from "#i18n/translations/en-US/place/extract/withdraw-request-details";
import { locationNotes } from "./location-notes";
import { debitNotes } from "./debit-notes";

export const extract = {
	title: "Extract",
	availableToWithdraw: "Available for withdrawal",
	owedToZig: "Balance due to ZIG",
	totalBalance: "Total balance",
	vendorOwned: "Due to suppliers",
	vendors: "Vendors",
	totalBalanceAnticipation: "Total balance for anticipation",
	valueAvailableToAnticipate: "Value available for anticipation",
	availableToAnticipate: "Available to anticipate",
	anticipationD30ZeroFee: "Anticipated credit balance available for withdrawal",
	paidToZig: "Amount to be paid to ZIG",
	availableMoreThanOneMonth: "Value available over 30 days",
	paidToZigMoreThanOneMonth: "Amount to be paid to ZIG in more than 30 days",
	actionLabelBlocked: "Withdraw / Pay bill",
	bankslipAvailable: "Bill available",
	dueDate_Abrev: "Exp",
	period: "Period",
	excelButton: "Export to Excel",
	tabs: {
		consolidated: "Consolidated",
		financial: "Daily statement",
		withdraws: "Withdrawals, advances and bankslips",
		devolution: "Expired recharges",
		adjustments: "Settings",
		accounts: "Saved accounts",
		flow: "Cash Flow Extract",
		locationNotes: "Location Notes",
		debitNotes: "Debit notes",
		automaticWithdraw: "Automatic withdraw",
	},
	consolidated,
	financial,
	withdraws,
	devolution,
	adjustments,
	accounts,
	flow,
	anticipationDrawer,
	withdrawRequestDrawer,
	errorsValidations,
	transferForm,
	withdrawConfirmation,
	bankSlipForm: {
		warningBanner: {
			title: "Attention",
			description:
				"Requests made after 10:30 am (Brasília time) will only be answered the next day.",
		},
		tryAgain: "Try again",
		request: "Request",
		error: "The request could not be completed.",
		success: "Payment of the ticket requested successfully!",
	},
	hooks: {
		value: "Anticipation Value",
		accountData: "Account Information",
		summary: "Data review",
	},
	availableInTwoDays: "Balance to be released in the next 2 days",
	availableInMoreThanOneMonth: "Amount to be released in more than 32 days",
	lastUpdated: "updated {{lastUpdated}} ago",
	withdrawRequestDetails,
	locationNotes,
	debitNotes,
	retainedBalance: "Retained balance",
	twentyPercentRetention: "20% retention of values ​​from the last 7 days",
	totalRetained: "Total retained",
	relatedPartDataTooltip: "Data specified from 21/05/2024",
	automaticWithdraw: {
		type: "Type",
		vendorName: "Vendor Name",
		expectedAmount: "Scheduled Withdraw Amount",
		placeBalance: "Place Balance",
		actualAmount: "Withdrawn Amount",
		status: "Status",
		vendor: "Vendor",
		place: "Place",
		error: "Error",
		success: "Success",
		partial: "Partial",
	},
};
